import { publishGa4Events } from '@porterin/component-library/src/ts-utils/analytics/react-ga/EventTracker';
import Link from 'next/link';
import React from 'react';

import { GA_HEADER_SPECIFIC_LINK_ACTION } from '../../../../containers/home/domain/store/HomeStoreEn';
import { LinkLabel } from '../../../types/CommonVM';
import styles from '../styles/Header.module.scss';
import { ga_header_event_prefix } from '../vm/HeaderStore';

interface PrimaryLinksComponentProps {
  for_enterprise_link?: LinkLabel;
  driver_partner_link: LinkLabel;
}

function PrimaryLinksComponent({
  for_enterprise_link,
  driver_partner_link,
}: Readonly<PrimaryLinksComponentProps>): React.ReactElement {
  const handleLinkClick = (label: string): void => {
    publishGa4Events(
      ga_header_event_prefix,
      GA_HEADER_SPECIFIC_LINK_ACTION,
      label,
    );
  };

  return (
    <div className={styles['primary-link']}>
      {for_enterprise_link ? (
        <Link
          href={for_enterprise_link.link}
          onClick={(): void => handleLinkClick(for_enterprise_link.label)}
        >
          {for_enterprise_link.label}
        </Link>
      ) : null}
      <Link
        href={driver_partner_link.link}
        onClick={(): void => handleLinkClick(driver_partner_link.label)}
      >
        {driver_partner_link.label}
      </Link>
    </div>
  );
}

export default PrimaryLinksComponent;
